/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import Typography from '../../../components/Typography';
import { Box, CardMedia, Grid } from '@mui/material';
import AnimalImage from '../../../assets/images/animal.png';
import ClothingImage from '../../../assets/images/clothing.png';
import FencingImage from '../../../assets/images/fencing.png';
import WaterManagementImage from '../../../assets/images/water-management.png';
import { SelectedFiltersType } from '../components/ProductFilter';
import TestIds from '../../../testIds';
import Card, { CardAction, CardTitle } from '../../../components/Card';

const items = [
  {
    title: 'Clothing',
    description: 'Check out our range of high quality clothing.',
    img: ClothingImage,
    category: 'Apparel',
  },
  {
    title: 'Animal nutrition',
    description: 'Shop our animal nutrition range by category or brand to meet your needs.',
    img: AnimalImage,
    category: 'Animal feed',
  },
  {
    title: 'Fencing',
    description: 'All fencing supplies including gates, fencing wire, fasteners and more.',
    img: FencingImage,
    category: 'Fencing',
  },
  {
    title: 'Water management',
    description: 'End-to-end stock water solutions. We design, source and deliver.',
    img: WaterManagementImage,
    category: 'Water management and irrigation',
  },
];
interface Props {
  selectedFilters: SelectedFiltersType;
}
export const AllProductsCover: React.FC<Props> = ({ selectedFilters }: Props) => {
  return (
    <>
      <Typography variant='h4'>Shop Farmlands products</Typography>
      <Grid container spacing={3} sx={{ mt: 1, maxWidth: '863px' }}>
        <Grid container item spacing={3}>
          {items.map((item) => (
            <Grid
              item
              xs={12}
              sm={6}
              key={item.title}
              sx={{ width: '424px' }}
              data-testid={TestIds.feat.product.cover.card}
            >
              <Card variant={'outlined'} sx={{ height: '100%' }}>
                <CardAction
                  onClick={() => selectedFilters.category.setValue(item.category)}
                  sx={{ p: 0, gap: 0 }}
                >
                  <CardMedia
                    component='img'
                    src={item.img}
                    title={`${item.title} image`}
                    alt={`${item.title} image`}
                  />
                  <Box p={2}>
                    <Box
                      sx={{ width: 'fit-content' }}
                      data-id={TestIds.feat.product.cover.cardId(item.title)}
                      data-testid={TestIds.feat.product.cover.cardId(item.title)}
                    >
                      <CardTitle title={item.title} showIcon={true} variant='h2' />
                    </Box>
                    <Typography
                      mt={1}
                      variant='body2'
                      data-testid={TestIds.feat.product.cover.description}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                </CardAction>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </>
  );
};
